// Sensitivity converter game presets (yawdeg = degrees per mouse count at
// sensitivity 1.0). Source: mikul's SensTool aim-game database
// (senstool, data/aimingpro_games.json), filtered to games with a known yaw.
// vfov/hfov are the game default FOVs (degrees); fovType says which one the
// game labels as its FOV.

export type SensFovType = "v" | "h" | "h4:3";

/** [name, yawdeg, vfov?, hfov?, fovType?] */
export const SENS_GAMES: ReadonlyArray<
  readonly [string, number, number?, number?, SensFovType?]
> = [
  ["webrace", 0.022],
  ["1v1.LOL", 0.006052164616, 50.534, 80],
  ["3D Aim Trainer", 0.006603773],
  ["7 Days to Die", 0.25, 70, 102.4479, "v"],
  ["Aim Gods", 0.0023331, 72.487, 105],
  ["Aim Lab", 0.05, 60, 91.4928, "v"],
  ["Aimtastic", 0.022, 70.53, 102.9971, "v"],
  ["ALARA Prime", 0.20855690168818275],
  ["Apex Legends", 0.022, 73.74, 106.26, "h4:3"],
  ["Arc Raiders", 0.001360975, 70, 102.4479, "v"],
  ["Arena Breakout: Infinite", 0.10237450588235296],
  ["ARK: Survival Ascended", 0.007],
  ["ARK: Survival Evolved", 0.17498152972],
  ["Arma 3", 0.05904385585, 56.25, 87.077],
  ["Back 4 Blood", 0.00233309976],
  ["Battalion 1944", 0.0175, 63.09, 95, "h"],
  ["Battle Teams 2", 0.05],
  ["BattleBit Remastered", 0.0005, 90, 121.2845, "v"],
  ["Battlefield 4", 0.004153944375],
  ["Battlefield 6", 0.00176303316709834, 58.7155, 90, "h"],
  ["Beyond Citadel", 0.175],
  ["Black Mesa", 0.022],
  ["Black Myth: Wukong", 0.01429166666666667],
  ["Black Squad", 0.005493164063, 61, 92.64, "v"],
  ["BlackShot: Mercenary Warfare FPS", 0.00035],
  ["Blood Strike", 0.0014323944444444444],
  ["Bloodhunt", 0.06605940942, 67.6727, 100, "h"],
  ["Bloxd.io", 0.006600000585989576],
  ["Bodycam", 0.1225],
  ["Borderlands 1/2", 0.005493164063, 58.72, 90, "h"],
  ["Borderlands 3", 0.007003891051, 58.7155, 90, "h"],
  ["BuildNow GG", 0.003],
  ["Caliber", 0.00125],
  ["Call of Duty: Black Ops 4", 0.006605686395, 58.72, 90],
  ["Call of Duty: Black Ops 6", 0.0066, 58.72, 90, "h"],
  ["Call of Duty: Black Ops Cold War", 0.0066, 58.72, 90],
  ["Call of Duty: Modern Warfare", 0.0066, 58.72, 90],
  ["Call of Duty: Warzone", 0.0066, 58.72, 90],
  ["Call of Duty: WWII", 0.022, 51.0772, 80.6909, "h4:3"],
  ["Chained Together", 0.175],
  ["Combat Master", 0.001],
  ["Concord", 0.07],
  ["Creative Destruction", 0.000390625, 50, 79.32, "v"],
  ["CrossFire", 0.004083333],
  ["CS 1.6", 0.022, 73.74, 106.26, "h"],
  ["CS:GO", 0.022, 73.74, 106.26, "h4:3"],
  ["CS2", 0.022, 73.74, 106.26, "h4:3"],
  ["Cyberpunk 2077", 0.01, 80, 50.534],
  ["Dark and Darker", 0.17498250174982502],
  ["Darwin Project", 0.00174504843, 58.72, 90],
  ["DayZ", 0.178571428571, 71.8443, 104.3462, "v"],
  ["Deadlock", 0.044, 46.8265, 75.1782, "h4:3"],
  ["DEADSHOT.io", 0.0716197407285855],
  ["Deep Rock Galactic", 0.000133667006, 67.6727, 100, "h"],
  ["Delta Force", 0.01, 58.7155, 90, "h"],
  ["Destiny 2", 0.0066, 51.8, 81.6],
  ["Diabotical", 0.022, 103, 131.7894, "v"],
  ["Doom Eternal", 0.022, 58.7155, 90],
  ["DOOM: The Dark Ages", 0.022],
  ["Dungeonborne", 0.0014],
  ["Dying Light", 0.008333333333, 52, 81.8558, "v"],
  ["Echo Point Nova", 0.00093324, 88.5072, 120, "h"],
  ["ELDEN RING NIGHTREIGN", 0.00971429],
  ["Enlisted", 0.05384615384615385],
  ["Escape from Tarkov", 0.125, 50, 79.3169, "v"],
  ["Fallout 4", 3.78, 50.534, 80],
  ["Fallout 76", 3.77992440151],
  ["Far Cry 3", 0.18, 58.19, 89.38, "h4:3"],
  ["Far Cry 4", 0.036, 47, 75],
  ["Far Cry 5", 0.022, 46.69, 75],
  ["Far Cry Primal", 0.053820025834, 47, 75],
  ["Farlight 84", 0.022072],
  ["Fate Trigger", 0.0000875],
  ["Fortnite", 0.005555, 56, 80],
  ["FragPunk", 0.05555002564102565],
  ["Garry's Mod", 0.022, 73.7398, 106.2602, "h4:3"],
  ["Gears 5", 0.012438884908, 50.53, 80],
  ["Gray Zone Warfare", 0.0630000001575],
  ["GTFO", 0.15],
  ["Half-Life 2", 0.02199999511],
  ["Halo", 0.022222222222, 49.2, 78.28, "h4:3"],
  ["Halo Infinite", 0.0225, 49.1491, 78.2205],
  ["Heroes & Generals", 0.151260504202, 60, 91.49, "v"],
  ["Hunt: Showdown", 0.042971834634811745, 55, 85.5656, "v"],
  ["Hyperscape", 0.005729577951308232, 65, 97.1143, "v"],
  ["Insurgency", 0.022, 73.7398, 106.2602, "h4:3"],
  ["Insurgency: Sandstorm", 0.14, 73.7398, 106.2602, "h4:3"],
  ["Ironsight", 0.01, 60, 91.4928, "h"],
  ["Just Cause 2", 0.0026857404651162795],
  ["Just Cause 3", 0.014651711475409838],
  ["Just Cause 4", 0.0004774648958333334],
  ["Kingdom Come: Deliverance", 0.01775999166666667],
  ["Kingdom Come: Deliverance II", 0.01775999166666667],
  ["KovaaK's", 0.021999999874285716],
  ["Krunker", 0.137509549274, 70, 102.4479, "v"],
  ["Left 4 Dead 2", 0.02199999511],
  ["Lethal Company", 0.008166666667],
  ["Line of Sight", 0.005493164063, 49.2, 78.28, "h"],
  ["Lost Light", 0.001590909090909091],
  ["Marathon", 0.0033, 58.7155, 90, "h"],
  ["Marvel Rivals", 0.0175, 58.5155, 90],
  ["Mecha BREAK", 0.08333333333333334],
  ["Metal Gear Solid Δ: Snake Eater", 0.021],
  ["Mini Royale", 0.09625],
  ["MiSide", 0.0030000000000000005],
  ["Monster Hunter Wilds", 0.006960816595324334],
  ["My Hero Ultra Rumble", 0.0006222222222222224],
  ["Naraka Bladepoint", 0.004083333333333334],
  ["New World", 1],
  ["osu!", 0.0796],
  ["Overwatch", 0.0066, 70.53, 103],
  ["Overwatch 2", 0.0066, 70.53, 103],
  ["Paladins", 0.009155273438, 67.67, 100, "h"],
  ["PANICORE", 0.175],
  ["Payday 2", 0.15, 51.08, 80.69, "h4:3"],
  ["Payday 3", 0.07, 60, 91.4928],
  ["Pixel Gun 3D: PC Edition", 0.0038684210526315796],
  ["Pixel Strike 3D", 0.03906248500000001],
  ["Point Blank", 0.2916666667],
  ["PUBG", 2.222, 59, 90],
  ["Quake Champions", 0.02199999511],
  ["Quake Live", 0.022, 83.58, 115.63, "h4:3"],
  ["Ready or Not", 0.175],
  ["Realm Royale", 0.009155273438, 58.72, 90, "h"],
  ["Redmatch 2", 0.05],
  ["Ring of Elysium", 2.222, 55, 85.57, "v"],
  ["Risk of Rain 2", 0.5],
  ["Roblox", 0.39789557451, 80, 112.3273, "v"],
  ["Roboquest", 0.000427735140562249],
  ["Rogue Company", 0.0227289, 42, 68.6212],
  ["Rust", 0.1125, 75, 107.51, "v"],
  ["s&box", 0.0078125, 58.7155, 90, "h"],
  ["Schedule I", 0.0016666666666666668],
  ["Serious Sam 2", 0.1718876066],
  ["Serious Sam 3", 0.1718876066],
  ["Serious Sam 4", 0.175],
  ["Serious Sam Classics: Revolution", 0.25],
  ["Silent Hill 2", 0.37329600000000007],
  ["Smite 2", 0.007324216666666667],
  ["Spectre Divide", 0.0715206, 70.53, 103, "h"],
  ["Spellbreak", 0.008],
  ["Splitgate", 0.93740625, 58.7155, 90],
  ["Splitgate 2", 0.011172707756232688, 58.7155, 90, "h"],
  ["Squad", 0.1749825, 58.7155, 90, "h"],
  ["Stalcraft", 0.006600000377142879],
  ["State of Decay 2", 0.014000000000000002],
  ["STRAFTAT", 0.10000000000000002],
  ["Strinova", 0.01388194445795501],
  ["Stumble Guys", 0.07875000000000001],
  ["Suit for Hire", 0.14],
  ["Team Fortress 2", 0.022, 59.84, 91.31, "h4:3"],
  ["THE FINALS", 0.000790322, 71, 103.4817, "v"],
  ["The First Berserker: Khazan", 0.0024],
  ["The Last of Us Part II", 0.003],
  ["Titanfall 2", 0.022, 55.41, 86.07],
  ["Tom Clancy's Rainbow 6 Extraction", 0.00572957914],
  ["Tom Clancy's Rainbow 6: Siege", 0.005729577951308232, 60, 91.49, "v"],
  ["Tom Clancy's The Division 2", 0.0044691, 43, 70.01, "v"],
  ["ULTRAKILL", 0.005],
  ["Unturned", 0.1, 90, 121.28, "v"],
  ["Valheim", 0.05, 65, 97.1143, "v"],
  ["Valorant", 0.07, 70.53, 103],
  ["War Rock", 0.0025],
  ["Warface", 0.00333000333, 59.84, 91.31, "h4:3"],
  ["Warframe", 0.007566132006, 65, 97.11, "v"],
  ["Warlander", 0.08333333333333334],
  ["World of Tanks", 0.14323967212731376],
  ["World of Tanks Blitz", 0.0007865168539325844],
  ["XDefiant", 0.00170729845, 67.67, 100, "h"],
  ["Xonotic", 0.022, 83.5817, 115.6336, "h4:3"],
  ["Zula", 0.12012012012, 62, 93.777, "v"],
];
